import PayPalConnectMessage from './PayPalConnectMessage';

export default PayPalConnectMessage;
